<template>
  <b-table-simple v-if="allows_crud || bibliography.length > 0" responsive>
    <b-tbody>
      <b-tr>
        <b-th colspan="2" class="text-center">
          {{
            $t(
              "matterProgram.matterProgramView.bibliographicResources"
            ).toUpperCase()
          }}
        </b-th>
      </b-tr>
      <b-tr
        v-for="bibliography_type in bibliographicResourceTypesFilterNonEmpty"
        :key="`bibliography-${bibliography_type.id}`"
      >
        <b-td style="width: 25%">
          <div class="d-flex justify-content-between align-items-center">
            <div class="flex-grow-1 text-center">
              <strong class="mr-1">{{ bibliography_type.name }} </strong>
              <b-icon-exclamation-circle
                v-b-tooltip.v-secondary="
                  $t('matterProgram.matterProgramView.canAddUpTo', {
                    max: bibliography_type.max_amount,
                  })
                "
              ></b-icon-exclamation-circle>
            </div>
            <div class="mt-1">
              <div
                v-if="
                  allows_crud &&
                  bibliography.filter((b) => b.type == bibliography_type.id)
                    .length < bibliography_type.max_amount &&
                  oldMatter &&
                  !oldMatter.is_closed &&
                  isClosedOldMatterPartial(bibliography_type)
                "
              >
                <ButtonMedium
                  v-if="can_update && allows_crud"
                  :tooltip_text="
                    $t('matterProgram.matterProgramView.addResourcesSeparately')
                  "
                  :click_button="
                    () =>
                      openModalBibliographicResourcesCreate(
                        bibliography_type.id
                      )
                  "
                  :text_button="``"
                  :icon="'plus'"
                  :variant="'primary'"
                  :custom_class="`p-0 mr-1 square-button`"
                >
                </ButtonMedium>
                <!-- <b-button
                @click="
                  $bvModal.show(
                    `create-bibliographic-resource-modal-${bibliography_type.id}-${matter_form_view}`
                  )
                "
                v-b-tooltip.v-secondary.noninteractive="
                  'Agregue los Recursos por separado'
                "
                variant="primary"
                size="sm"
              >
                Agregar Recurso
              </b-button> -->
                <ContainerRichTextKlv3
                  :id_modal="`create-bibliographic-resource-modal-${bibliography_type.id}-${matter_form_view}`"
                  :title_modal="
                    $t(
                      'matterProgram.matterProgramView.createBibliographicResource'
                    )
                  "
                  :size_modal="`lg`"
                  :show_last_modification="true"
                  :allow_list_mode="true"
                  @hide="hideModaltoMatterProgram"
                  @save="
                    (content) => createBibliography(content, bibliography_type)
                  "
                  @save-list="
                    (contents) =>
                      createBibliographies(contents, bibliography_type)
                  "
                  @close="closeModal(bibliography_type.id)"
                >
                </ContainerRichTextKlv3>
                <!-- <b-modal
                  :id="`create-bibliographic-resource-modal-${bibliography_type.id}-${matter_form_view}`"
                  title="Crear Recurso Bibliográfico"
                  size="lg"
                  hide-footer
                  ignore-enforce-focus-selector="#sidebar-right"
                >
                  <NewRichTextEditor
                    :Type="bibliography_type"
                    @save="createBibliography"
                    @close="closeModal(bibliography_type.id)"
                  ></NewRichTextEditor>
                </b-modal> -->
              </div>
              <div
                v-else-if="
                  allows_crud &&
                  oldMatter &&
                  !oldMatter.is_closed &&
                  isClosedOldMatterPartial(bibliography_type)
                "
              >
                <ButtonMedium
                  :tooltip_text="
                    $t(
                      'matterProgram.matterProgramView.exceededMaxBibliographicResources'
                    )
                  "
                  :text_button="``"
                  :disabled_button="true"
                  :icon="'plus'"
                  :variant="'primary'"
                  :custom_class="`p-0 mr-1 square-button`"
                >
                </ButtonMedium>
                <!-- <b-button disabled variant="primary" size="sm">
                Agregar Recurso
              </b-button> -->
              </div>
            </div>
          </div>
        </b-td>
        <b-td>
          <div>
            <div
              v-for="biblio in bibliography.filter(
                (b) => b.type == bibliography_type.id
              )"
              :key="`bibliography-${biblio.id}`"
              class="border-resource"
            >
              <div style="display: flex">
                <RenderVHtml
                  class="w-100 support-resource-content"
                  :content="biblio.description"
                ></RenderVHtml>
                <div
                  v-if="
                    allows_crud &&
                    oldMatter &&
                    !oldMatter.is_closed &&
                    isClosedOldMatterPartial(bibliography_type)
                  "
                  class="container-btn-blibliographic"
                >
                  <div class="d-flex p-1">
                    <ButtonSmall
                      v-if="can_update && allows_crud"
                      tabindex="-1"
                      :tooltip_text="$t('reusable.common.edit')"
                      :click_button="
                        () => openModalBibliographicResourcesEdit(biblio.id)
                      "
                      :class="`w-30`"
                      :icon="'square'"
                    ></ButtonSmall>
                    <!-- <button-edit
                      tabindex="-1"
                      class="w-30"
                      @click="
                        $bvModal.show(
                          `edit-bibliographic-resource-modal-${biblio.id}-${matter_form_view}`
                        )
                      "
                    >
                    </button-edit> -->
                    <ButtonSmall
                      v-if="can_delete && allows_crud"
                      tabindex="-1"
                      :click_button="
                        () => deleteBibliography(biblio, bibliography_type.name)
                      "
                      :tooltip_text="$t('reusable.common.delete')"
                      :class="`w-30`"
                      :icon="'trash'"
                    ></ButtonSmall>
                    <!-- <button-delete
                      tabindex="-1"
                      class="w-30"
                      @click="
                        deleteBibliography(biblio, bibliography_type.name)
                      "
                    ></button-delete> -->
                  </div>
                  <ContainerRichTextKlv3
                    :id_modal="`edit-bibliographic-resource-modal-${biblio.id}-${matter_form_view}`"
                    :title_modal="
                      $t(
                        'matterProgram.matterProgramView.editBibliographicResource'
                      )
                    "
                    :size_modal="`lg`"
                    :object_rich_text="biblio"
                    :content_rich_text="biblio.description"
                    :show_last_modification="true"
                    @hide="hideModaltoMatterProgram"
                    @save="(content) => updateBibliography(biblio, content)"
                    @close="closeModal(biblio.id)"
                  >
                  </ContainerRichTextKlv3>
                  <!-- <b-modal
                    :id="`edit-bibliographic-resource-modal-${biblio.id}-${matter_form_view}`"
                    title="Editar Recurso Bibliográfico"
                    size="lg"
                    hide-footer
                    ignore-enforce-focus-selector="#sidebar-right"
                  >
                    Copie y edite los contenidos por separado
                    <NewRichTextEditor
                      :Object="biblio"
                      :Text="biblio.description"
                      @save="updateBibliography"
                      @close="closeModal(biblio.id)"
                    ></NewRichTextEditor>
                  </b-modal> -->
                </div>
              </div>
            </div>
          </div>
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import * as names from "@/store/names";
import { toast } from "@/utils/utils";
import { mapGetters } from "vuex";

export default {
  name: "BibliographicResourcesComponent",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
  },
  props: {
    oldMatter: {
      type: Object,
      required: true,
    },
    matter_form_view: {
      type: Boolean,
      default: false,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    filter_object_in_view: {
      type: Boolean,
      default: false,
    },
    matter: {
      type: [Object, null],
    },
  },
  data() {
    return {
      bibliographies: [],
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      bibliographicResourceTypes: names.BIBLIOGRAPHIC_RESOURCE_TYPES,
    }),
    bibliography() {
      return this.bibliographies;
    },
    bibliographicResourceTypesFilterNonEmpty() {
      if (this.allows_crud) return this.bibliographicResourceTypesFilter;
      return this.bibliographicResourceTypesFilter.filter((bt) =>
        this.bibliography.some((b) => b.type == bt.id)
      );
    },
    bibliographicResourceTypesFilter() {
      if (this.filter_object_in_view) {
        return this.bibliographicResourceTypes.filter((x) =>
          this.$equals(x.name, "Obligatoria")
        );
      } else return this.bibliographicResourceTypes;
    },
  },
  methods: {
    insertStoreOpenAiQuestion() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [8],
        disabled_selected_intelligence_option: true,
      });
    },
    openModalBibliographicResourcesCreate(bibliographic_type_id) {
      this.insertStoreOpenAiQuestion();
      if (this.matter) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: this.matter.id,
            egress_profile_matter_id: this.matter.id,
            egress_profile_id: this.matter.egress_profile,
            extra_label: `Recursos Biliográficos`,
            intelligence_option: 8,
            sub_option: 6,
          });
        });
      }
      this.$bvModal.show(
        `create-bibliographic-resource-modal-${bibliographic_type_id}-${this.matter_form_view}`
      );
    },
    openModalBibliographicResourcesEdit(bibliographic_id) {
      this.insertStoreOpenAiQuestion();
      if (this.matter) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: this.matter.id,
            egress_profile_matter_id: this.matter.id,
            egress_profile_id: this.matter.egress_profile,
            extra_label: `Recursos Biliográficos`,
            intelligence_option: 8,
            sub_option: 6,
          });
        });
      }
      this.$bvModal.show(
        `edit-bibliographic-resource-modal-${bibliographic_id}-${this.matter_form_view}`
      );
    },
    hideModaltoMatterProgram() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      if (this.matter) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            egress_profile_id: this.matter.egress_profile,
            egress_profile_matter_id: this.matter.id,
            competence_unit_id: null,
            intelligence_option: 2,
          });
          this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
            visible_intelligence_options: [2, 3, 4, 5, 6, 7],
            disabled_selected_egress_profile: true,
            disabled_selected_egress_profile_matter: true,
            disabled_selected_study_unit: null,
            disabled_selected_competence_unit: null,
          });
        });
      }
    },
    isClosedOldMatterPartial(support_resource_type) {
      if (this.oldMatter) {
        if (this.institution && this.institution.internal_use_id == "duoc.cl") {
          if (this.$equals(support_resource_type.name, "Obligatoria")) {
            return !this.oldMatter.bibliography_locked_view;
          } else return true;
        } else {
          return !this.oldMatter.bibliography_locked_view;
        }
      } else return false;
    },
    deleteBibliography(bibliography, type_name) {
      this.$swal({
        title: this.$t(
          "matterProgram.matterProgramView.deleteBibliographicResourceConfirm",
          {
            type: type_name,
          }
        ),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful
            .Delete(`/teaching/bibliographic-resource/${bibliography.id}/`)
            .then(() => {
              let index = this.bibliography.findIndex(
                (b) => b.id == bibliography.id
              );
              if (index != -1) {
                this.$emit("change_bibliographic_resource");
                this.bibliography.splice(index, 1);
                this.$restful.Post(`/teaching/send_bibliographic_alert/`, {
                  action: "delete",
                  egress_profile_matter: this.matter ? this.matter.id : null,
                  matter: this.oldMatter.id,
                  bibliographic_resource: bibliography.id,
                  bibliographic_resource_type: bibliography.type,
                  old_description: bibliography.description,
                });
              }
            });
        }
      });
    },
    updateBibliography(biblio, text) {
      let item = {
        description: text,
      };
      const biblio_description = biblio.description;
      this.$restful
        .Patch(`/teaching/bibliographic-resource/${biblio.id}/`, item)
        .then((response) => {
          const index = this.bibliography.findIndex((b) => b.id == biblio.id);
          if (index != -1) {
            this.$emit("change_bibliographic_resource");
            this.bibliography[index].description = response.description;
            this.bibliography[index].created_by = response.created_by;
            this.bibliography[index].updated_by = response.updated_by;
            this.bibliography[index].creation_date = response.creation_date;
            this.bibliography[index].update_date = response.update_date;
            this.$bvModal.hide(
              `edit-bibliographic-resource-modal-${biblio.id}-${this.matter_form_view}`
            );
            this.$restful.Post(`/teaching/send_bibliographic_alert/`, {
              action: "update",
              egress_profile_matter: this.matter ? this.matter.id : null,
              matter: this.oldMatter.id,
              bibliographic_resource: response.id,
              new_description: response.description,
              bibliographic_resource_type: response.type,
              old_description: biblio_description,
            });
          }
        });
    },
    createBibliography(text, bibliography_type) {
      if (this.oldMatter.id) {
        let item = {
          description: text,
          type: bibliography_type.id,
          matter: this.oldMatter.id,
        };
        this.$restful
          .Post(`/teaching/bibliographic-resource/`, item)
          .then((response) => {
            this.$emit("change_bibliographic_resource");
            this.bibliography.push(response);
            this.$bvModal.hide(
              `create-bibliographic-resource-modal-${bibliography_type.id}-${this.matter_form_view}`
            );
            this.$restful.Post(`/teaching/send_bibliographic_alert/`, {
              action: "create",
              egress_profile_matter: this.matter ? this.matter.id : null,
              matter: this.oldMatter.id,
              bibliographic_resource: response.id,
              bibliographic_resource_type: response.type,
              new_description: response.description,
            });
          });
      }
    },
    // Modo lista: crea un recurso por línea, sin pasar del máximo del tipo
    createBibliographies(texts, bibliography_type) {
      if (!this.oldMatter.id) return;
      const used_amount = this.bibliography.filter(
        (b) => b.type == bibliography_type.id
      ).length;
      if (used_amount + texts.length > bibliography_type.max_amount) {
        toast(
          this.$t("matterProgram.matterProgramView.canAddUpTo", {
            max: bibliography_type.max_amount,
          })
        );
        return;
      }
      const items = texts.map((text) => ({
        description: text,
        type: bibliography_type.id,
        matter: this.oldMatter.id,
      }));
      this.$restful
        .Post(`/teaching/bibliographic-resource/bulk-create/`, items)
        .then((response) => {
          this.$emit("change_bibliographic_resource");
          response.forEach((resource) => {
            this.bibliography.push(resource);
            this.$restful.Post(`/teaching/send_bibliographic_alert/`, {
              action: "create",
              egress_profile_matter: this.matter ? this.matter.id : null,
              matter: this.oldMatter.id,
              bibliographic_resource: resource.id,
              bibliographic_resource_type: resource.type,
              new_description: resource.description,
            });
          });
          this.$bvModal.hide(
            `create-bibliographic-resource-modal-${bibliography_type.id}-${this.matter_form_view}`
          );
        });
    },
    closeModal(resource_id) {
      this.$bvModal.hide(
        `edit-resource-modal-${resource_id}-${this.matter_form_view}`
      );
      this.$bvModal.hide(
        `create-resource-modal-${resource_id}-${this.matter_form_view}`
      );
    },
    fetchBibliography() {
      if (this.oldMatter) {
        this.$restful
          .GetAll(`/teaching/bibliographic-resource/?matter=${this.oldMatter.id}`)
          .then((response) => {
            this.bibliographies = response.sort((a, b) => a.id - b.id);
          });
      }
    },
  },
  created() {
    this.$store.dispatch(names.FETCH_BIBLIOGRAPHIC_RESOURCE_TYPES);
    this.fetchBibliography();
  },
};
</script>

<style scoped>
span >>> .square-button {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-btn-blibliographic {
  display: flex;
  align-items: center;
}
.border-resource {
  border-bottom: 1px solid black;
}
.border-resource:last-child {
  border-bottom: none;
}
table {
  width: 100%;
  table-layout: auto;
}
table td {
  border: 1px solid var(--kl-table-border) !important;
  text-align: center;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
table th {
  vertical-align: middle;
  border: 1px solid var(--kl-table-border) !important;
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.th-header {
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-size: var(--primary-font-size);
}
@media print {
  .bibliography-content,
  .support-resource-content {
    text-overflow: ellipsis;
    word-wrap: break-word;
    max-width: 800px !important;
  }
}
</style>